import { createAction } from "redux-actions";
import { moduleSlug } from "modules/Branches/services/constants";

export const clearBranches = createAction(`${moduleSlug}/CLEAR_BRANCHES`);

export const getBranches = createAction(`${moduleSlug}/GET_BRANCHES`);
export const getBranchesSuccess = createAction(`${moduleSlug}/GET_BRANCHES/SUCCESS`);
export const getBranchesError = createAction(`${moduleSlug}/GET_BRANCHES/ERROR`);

export const getBranchByCode = createAction(`${moduleSlug}/GET_BRANCH_BY_CODE`);
export const getBranchByCodeSuccess = createAction(`${moduleSlug}/GET_BRANCH_BY_CODE/SUCCESS`);
export const getBranchByCodeError = createAction(`${moduleSlug}/GET_BRANCH_BY_CODE/ERROR`);

export const updateBranch = createAction(`${moduleSlug}/UPDATE_BRANCH`);
export const updateBranchSuccess = createAction(`${moduleSlug}/UPDATE_BRANCH/SUCCESS`);
export const updateBranchError = createAction(`${moduleSlug}/UPDATE_BRANCH/ERROR`);

export const updateBranchPartially = createAction(`${moduleSlug}/UPDATE_BRANCH_PARTIALLY`);
export const updateBranchPartiallySuccess = createAction(`${moduleSlug}/UPDATE_BRANCH_PARTIALLY/SUCCESS`);
export const updateBranchPartiallyError = createAction(`${moduleSlug}/UPDATE_BRANCH_PARTIALLY/ERROR`);

export const createBranch = createAction(`${moduleSlug}/CREATE_BRANCHES`);
export const createBranchSuccess = createAction(`${moduleSlug}/CREATE_BRANCHES/SUCCESS`);
export const createBranchError = createAction(`${moduleSlug}/CREATE_BRANCHES/ERROR`);

export const setSelectedBranches = createAction(`${moduleSlug}/SET_SELECTED_BRANCHES`);

export const deleteBranch = createAction(`${moduleSlug}/DELETE_BRANCH`);
